import formatValue from "../../../utils/formatValue";
import { IYearOverYearInsight } from "../types/ownerDashboard.types";
import { formatRevenueMonthLabel } from "./parseRevenueMonthDate";

export interface YearOverYearDisplay {
  headline: string;
  comparisonLabel: string;
  isPositive: boolean;
}

export function formatYearOverYearInsight(
  insight: IYearOverYearInsight | null | undefined
): YearOverYearDisplay | null {
  if (!insight || insight.previous_year_value <= 0) {
    return null;
  }

  const sign = insight.variation_pct >= 0 ? "+" : "";
  const comparisonMonthLabel = formatRevenueMonthLabel(insight.comparison_month);
  const previousYearMonthLabel = formatRevenueMonthLabel(insight.previous_year_month);

  return {
    headline: `${sign}${insight.variation_pct.toFixed(2)}% em relação a ${previousYearMonthLabel}`,
    comparisonLabel: `${comparisonMonthLabel}: ${formatValue(insight.current_value)} · ${previousYearMonthLabel}: ${formatValue(insight.previous_year_value)}`,
    isPositive: insight.variation_pct >= 0,
  };
}
